export const BUSINESS = {
  name: "GTA Modern Painting",
  phoneDisplay: "(416) 732-4181",
  phoneHref: "tel:+14167324181",
  email: "gtamodernpainting@gmail.com",
  whatsappHref:
    "https://wa.me/14167324181?text=Hi%20GTA%20Modern%20Painting%2C%20I%27d%20love%20a%20quote%20for%20my%20home.",
  coverage: "Toronto, Mississauga, Brampton, Vaughan, Markham & the GTA",
  offer: "$100 off your first full-home project",
};

export const REAL_PROJECT_ASSETS = {
  prepStill:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_gta-paint-quotes-1/artifacts/r2mv04se_20260808_141508.webp",
  revealStill:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_gta-paint-quotes-1/artifacts/g7r6gdnb_20260811_122017.webp",
  sideStill:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_gta-paint-quotes-1/artifacts/1wy78id9_20260811_122012.webp",
  loftInterior:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_gta-paint-quotes-1/artifacts/b40cbav4_20260417_162703.webp",
  kitchenWide:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_gta-paint-quotes-1/artifacts/ov8r74s5_20260505_152008.webp",
  kitchenDetail:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_gta-paint-quotes-1/artifacts/ri73rn0k_20260505_152005.webp",
  frontDoor:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_gta-paint-quotes-1/artifacts/opc7swzu_20260623_102628.webp",
  waterfrontRoom:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_gta-paint-quotes-1/artifacts/51uiot5l_20260724_114341.webp",
  walkthroughOne:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_gta-paint-quotes-1/artifacts/qbn4a3ug_20260713_112517.mp4",
  walkthroughTwo:
    "https://customer-assets-wrfwihn1.emergentagent.net/job_gta-paint-quotes-1/artifacts/h4hxombc_20260713_104827.mp4",
};

export const HERO_FRAMES = [
  {
    title: "Fresh exterior reveal",
    mediaType: "video",
    src: REAL_PROJECT_ASSETS.walkthroughOne,
    poster: REAL_PROJECT_ASSETS.revealStill,
    rotation: 90,
  },
  {
    title: "Waterfront interior refresh",
    mediaType: "image",
    src: REAL_PROJECT_ASSETS.waterfrontRoom,
    rotation: 90,
  },
  {
    title: "Cabinet finish detail",
    mediaType: "image",
    src: REAL_PROJECT_ASSETS.kitchenWide,
    rotation: 90,
  },
];

export const MANIFESTO_CHAPTERS = [
  {
    number: "01",
    title: "Prep like the finish depends on it.",
    text: "Sanding, filling, masking, dust control, and surfaces that are ready to hold colour beautifully — not just quickly.",
  },
  {
    number: "02",
    title: "Quote clarity beats sales pressure.",
    text: "A fast estimate range, a clean scope, and timelines homeowners can actually trust before the first brush ever lands.",
  },
  {
    number: "03",
    title: "Homes should feel edited, not just painted.",
    text: "Our process is built around balance, undertones, natural light, and how the finished room photographs and lives every day.",
  },
];

export const FAQS = [
  {
    question: "How accurate is the instant estimator?",
    answer:
      "It gives a smart preliminary range based on room size, finish level, condition, and local market context. After photos or an on-site visit, we tighten it into a final quote.",
  },
  {
    question: "Do you handle occupied homes?",
    answer:
      "Yes. We sequence rooms, reset the site daily, and use low-odour systems whenever possible so families can stay comfortable during the project.",
  },
  {
    question: "What areas do you serve?",
    answer:
      "Toronto, Mississauga, Brampton, Vaughan, Markham, Richmond Hill, and nearby GTA neighbourhoods.",
  },
];

export const SERVICE_PAGES = [
  {
    slug: "interior-painting",
    name: "Interior Painting",
    eyebrow: "Service / Interior",
    summary:
      "For living rooms, hallways, bedrooms, stairwells, condos, and full-home repaints that need sharp details and a calm process.",
    image: REAL_PROJECT_ASSETS.loftInterior,
    rotation: 90,
    bullets: [
      "Walls, ceilings, trim, doors, and feature walls",
      "Patch-and-repair packages before colour goes on",
      "Daily cleanup and furniture protection included",
    ],
  },
  {
    slug: "exterior-painting",
    name: "Exterior Painting",
    eyebrow: "Service / Exterior",
    summary:
      "Weather-ready coating systems for curb appeal upgrades, preventative maintenance, and full façade resets across the GTA.",
    image: REAL_PROJECT_ASSETS.revealStill,
    rotation: 90,
    bullets: [
      "Siding, brick accents, stucco, trim, shutters, and doors",
      "Surface prep built for seasonal durability",
      "Ideal for listings, remodels, and older homes needing protection",
    ],
  },
  {
    slug: "cabinet-painting",
    name: "Cabinet Painting",
    eyebrow: "Service / Cabinets",
    summary:
      "Factory-style cabinet refinishing for kitchens and built-ins when you want the wow of a renovation without full replacement.",
    image: REAL_PROJECT_ASSETS.kitchenWide,
    rotation: 90,
    bullets: [
      "Door and drawer refinishing workflows",
      "Primer and enamel systems for smoother curing",
      "Perfect with countertop or lighting refreshes",
    ],
  },
  {
    slug: "trim-and-doors",
    name: "Trim & Doors",
    eyebrow: "Service / Detail Work",
    summary:
      "A precision package for baseboards, casings, crown, stair trim, and feature doors that need a furniture-grade finish.",
    image: REAL_PROJECT_ASSETS.frontDoor,
    rotation: 90,
    bullets: [
      "Brush and spray strategies depending on the surface",
      "Ideal when the walls already work but details need elevation",
      "Pairs well with hallway, condo, and resale refresh projects",
    ],
  },
];

export const LOCATION_PAGES = [
  {
    slug: "toronto",
    city: "Toronto",
    title: "Residential painters in Toronto",
    summary:
      "From semis and downtown condos to detached family homes, Toronto projects often need careful staging, quick resets, and colour choices that work under mixed natural light.",
  },
  {
    slug: "mississauga",
    city: "Mississauga",
    title: "Residential painters in Mississauga",
    summary:
      "Mississauga homeowners often blend repainting with kitchen and bath updates, so we shape estimates around phased renovation timelines.",
  },
  {
    slug: "brampton",
    city: "Brampton",
    title: "Residential painters in Brampton",
    summary:
      "Large family homes and high-traffic areas benefit from durable wall systems, trim detailing, and low-friction scheduling.",
  },
  {
    slug: "vaughan",
    city: "Vaughan",
    title: "Residential painters in Vaughan",
    summary:
      "Vaughan clients typically ask for premium finishes, custom palette support, and strong curb appeal for newer homes and remodels.",
  },
  {
    slug: "markham",
    city: "Markham",
    title: "Residential painters in Markham",
    summary:
      "Markham homes often need a balance of modern neutrals and trim contrast to bring natural light forward without losing warmth.",
  },
];

export const TIME_SLOTS = [
  "09:00",
  "11:00",
  "13:00",
  "15:00",
  "17:00",
];

export const MARQUEE_WORDS = [
  "Toronto interiors",
  "premium prep",
  "cabinet refinishing",
  "same-day quote callbacks",
  "curb appeal upgrades",
  "GTA coverage",
];
